import {HTTP} from "../../_helpers/http";
import {config} from "@shared/_services/config";

function deserializeContent(item) {
    let res = {
        ...item,
        contentDataSet: {}
    };

    item.template.templateFields.forEach(template => {
        let dataSet = item.contentDataSet.find(dataSet => {
            return dataSet && dataSet.templateField.name === template.name;
        });

        if (dataSet) {
            res.contentDataSet[template.name] = {
                value: toValue(dataSet),
                id: dataSet.id,
                type: dataSet.templateField.type,
                templateField: dataSet.templateField
            }
        } else {
            res.contentDataSet[template.name] = {
                value: '',
                templateField: template
            };
        }
    });

    return res;
}

function toValue(item) {
    switch (item.templateField.type) {
        case "DATE":
            return item.dateValue;
        case "BOOL":
            return item.boolValue;
        case "TEXT":
        case "IMAGE":
        case "SIMPLE_LIST":
            return item.stringValue;
        case "DESIGN_SHOP_TILE_SELECT":
        case "CATEGORY_SELECT":
            return parseInt(item.stringValue);
        case "HTML":
        case "LONG_TEXT":
            return item.lobValue;
        case "TREND_SHOP_TILE":
        case "DESIGN_SHOP_TILE":
        case "DESIGN_SHOP_TILE_LIST":
        case "IMAGE_GRID":
            return JSON.parse(item.lobValue);
    }
}

function fromValue(item) {
    let contentDataSetItem = {
        id: item.id,
        lobValue: null,
        stringValue: null,
        boolValue: null,
        dateValue: null,
        templateField: item.templateField
    };
    switch (item.templateField.type) {
        case "DATE":
            contentDataSetItem.dateValue = item.value;
            break;
        case "BOOL":
            contentDataSetItem.boolValue = item.value;
            break;
        case "TEXT":
        case "IMAGE":
        case "DESIGN_SHOP_TILE_SELECT":
        case "SIMPLE_LIST":
        case "CATEGORY_SELECT":
            contentDataSetItem.stringValue = item.value;
            break;
        case "HTML":
        case "LONG_TEXT":
            contentDataSetItem.lobValue = item.value;
            break;
        case "TREND_SHOP_TILE":
        case "DESIGN_SHOP_TILE":
        case "DESIGN_SHOP_TILE_LIST":
        case "IMAGE_GRID":
            contentDataSetItem.lobValue = JSON.stringify(item.value);
            break;
    }
    return contentDataSetItem;
}

export default class ContentAPI {

    static fetchPageList() {
        return HTTP.get(`${config.contentApi.content}`)
            .then(response => {

                return response.data.map(item => {
                    return deserializeContent(item);
                })
            });
    }

    static fetchPageByName(name) {
        return HTTP.get(`${config.contentApi.content}/${name}`)
            .then(response => {
                return deserializeContent(response.data);
            });
    }


    static fetchListByName(name) {
        return HTTP.get(`${config.contentApi.list}/${name}`)
            .then(response => {

                return response.data.map(item => {
                    let res = {
                        id: item.id,
                        template: item.template
                    };

                    for (let i = 0; i < item.contentDataSet.length; ++i) {
                        let itemKey = item.contentDataSet[i].templateField.name;
                        res[itemKey] = {
                            value: toValue(item.contentDataSet[i]),
                        }
                    }

                    return res;
                })
            });
    }

    static updateList(list) {
        return HTTP.put(`/cms/list`, list)
            .then(response => response.data);
    }

    static addList(list, templateId) {
        return HTTP.post(`/cms/list/template/${templateId}`, list)
            .then(response => response.data);
    }

    static insertListItem(content) {
        let res = {
            id: content.id,
            template: content.template,
            contentDataSet: [],
            name: content.name,
            label: content.label,
        };
        Object.keys(content.contentDataSet).forEach(key => {
            let item = content.contentDataSet[key];
            res.contentDataSet.push(fromValue(item));
        });
        return HTTP.post(`${config.contentApi.listAdmin}/${content.listId}`, res)
            .then(response => response.data);
    }

    static insert(content) {
        let res = {
            template: content.template,
            contentDataSet: [],
            name: content.name,
            label: content.label,
        };
        Object.keys(content.contentDataSet).forEach(key => {
            let item = content.contentDataSet[key];
            res.contentDataSet.push(fromValue(item));
        });

        return HTTP.post(config.contentApi.contentAdmin, res)
            .then(response => response.data);
    }

    static delete(contentId) {
        return HTTP.delete(`${config.contentApi.contentAdmin}/${contentId}`)
            .then(response => response.data);
    }

    static deleteList(listId) {
        return HTTP.delete(`/cms/list/${listId}`)
            .then(response => response.data);
    }



    static update(content) {
        let res = {
            template: content.template,
            contentDataSet: [],
            name: content.name,
            label: content.label,
            id: content.id
        };
        Object.keys(content.contentDataSet).forEach(key => {
            res.contentDataSet.push(fromValue(content.contentDataSet[key]));
        });
        return HTTP.put(config.contentApi.contentAdmin, res)
            .then(response => response.data);
    }

    static fetchList() {
        return HTTP.get(config.contentApi.list)
            .then(response => {
                if (response.data) {
                    return response.data.map(listItem => {
                        return {
                            id: listItem.id,
                            label: listItem.label,
                            name: listItem.name,
                            contentList: listItem.contentList.map(item => {
                                return deserializeContent(item);
                            }),
                            fields: listItem.template.templateFields.map(item => {
                                return item.name;
                            }),
                            schema: listItem.template.templateFields,
                            template: listItem.template
                        }
                    });
                }
                return null;
            });
    }
}